<card-analytics titleText="Revenue Analysis" contentClass="sales-by-state grid">
  <dx-data-grid
    [dataSource]="data"
    [height]="290"
    [loadPanel]="{ enabled: false }"
  >
    <dxi-column caption="State" dataField="stateName"> </dxi-column>

    <dxi-column
      alignment="left"
      caption="Sales"
      dataField="total"
      dataType="number"
      format="currency"
      sortOrder="desc"
      [hidingPriority]="2"
    >
    </dxi-column>

    <dxi-column
      alignment="left"
      caption="% Sold"
      dataField="percentage"
      name="percentN"
      format="percent"
      [hidingPriority]="1"
    >
    </dxi-column>

    <dxi-column
      alignment="left"
      caption="Percentage"
      dataField="percentage"
      name="percentB"
      cellTemplate="salesBullet"
      cssClass="sales-bullet"
      [width]="200"
    >
    </dxi-column>

    <div *dxTemplate="let cellInfo of 'salesBullet'">
      <dx-bullet
        [showTarget]="false"
        [showZeroLevel]="false"
        [value]="cellInfo.data.percentage * 100"
        [startScaleValue]="0"
        [endScaleValue]="100"
      >
        <dxo-tooltip [enabled]="false"></dxo-tooltip>
        <dxo-size [width]="200" [height]="20"></dxo-size>
      </dx-bullet>
    </div>
  </dx-data-grid>
</card-analytics>
